import { render, staticRenderFns } from "./IconExtension.vue?vue&type=template&id=accfff2e&"
import script from "./IconExtension.vue?vue&type=script&lang=js&"
export * from "./IconExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('accfff2e')) {
      api.createRecord('accfff2e', component.options)
    } else {
      api.reload('accfff2e', component.options)
    }
    module.hot.accept("./IconExtension.vue?vue&type=template&id=accfff2e&", function () {
      api.rerender('accfff2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconExtension.vue"
export default component.exports